import {RGB_COLOR_REGEXP} from '../widgets/floorplan/utils/consts';
import {COLOR_BLACK} from '../../modules/ruleengine/config/consts';
import {WidgetSvg} from '../widgets/floorplan/hooks/types';

type IntervalStore = Record<string, number | null | undefined>;

const blinkIntervalIds: IntervalStore = {};

const rbgToHex = (r: number, g: number, b: number) => {
	const red = r.toString(16);
	const green = g.toString(16);
	const blue = b.toString(16);
	const realRed = red.length == 1 ? '0' + red : red;
	const realGreen = green.length == 1 ? '0' + green : green;
	const realBlue = blue.length == 1 ? '0' + blue : blue;
	return '#' + realRed + realGreen + realBlue;
};

const setColorAndFlashing = (
	assetId: number | null | undefined,
	element: WidgetSvg,
	blinkDataPointName: string,
	color: string,
	frequency: number | null | undefined,
	widgetKey: string
): void => {
	if (assetId) {
		const intervalProp = `${widgetKey}_${assetId}_${blinkDataPointName}`;
		const blinkIntervalId = blinkIntervalIds[intervalProp];

		if (blinkIntervalId) {
			clearInterval(blinkIntervalId);
			blinkIntervalIds[intervalProp] = undefined;
		}

		if (frequency && color !== COLOR_BLACK) {
			blinkIntervalIds[intervalProp] = window.setInterval(() => {
				const elementMembers = element.members[0];
				const rgba = elementMembers.style('fill');

				const colors = rgba.match(RGB_COLOR_REGEXP);

				if (colors && colors.length === 3) {
					const hex = rbgToHex(parseInt(colors[0]), parseInt(colors[1]), parseInt(colors[2]));
					const toggleColor = hex === color.toLowerCase() ? '#666' : color;
					elementMembers.style('fill', toggleColor);
				}
			}, frequency);
		} else {
			element.style('fill', color);
		}
	}
};

const clearAllBlinks = (): void => {
	Object.keys(blinkIntervalIds).forEach((intervalKey) => {
		const blinkIntervalId = blinkIntervalIds[intervalKey];
		if (blinkIntervalId) {
			clearInterval(blinkIntervalId);
			blinkIntervalIds[intervalKey] = undefined;
		}
	});
};

export {setColorAndFlashing, clearAllBlinks};
